export default "__VITE_ASSET__B3S3uUF1__"